import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { List, ListType } from 'crono-fe-common/types/list';

export interface ICreateList {
  name: string;
  type: ListType;
  shared?: boolean;
  sharedUsersIds?: number[];
  memberIds?: number[];
  objectIds?: number[];
  ids?: number[];
}

export default function useCreateList() {
  const queryClient = useQueryClient();

  const createList = (newList: ICreateList) => {
    const request: Request = {
      url: `${ENDPOINTS.list.main}`,
      config: {
        method: 'post',
        data: { data: newList },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<List>,
    CronoError,
    ICreateList
  >(createList, {
    onSettled: () => {
      invalidateListQueries(queryClient);
    },
  });

  return { data, mutate, ...rest };
}

export const invalidateListQueries = async (queryClient: QueryClient) => {
  queryClient.invalidateQueries([ENDPOINTS.list.search]);
  queryClient.invalidateQueries([ENDPOINTS.user.search]);
};
